import React from 'react'
import { SvgIconProps } from './Home'

const SvgMyProfileIcon = ({ fill }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="18"
    fill="none"
    viewBox="0 0 15 18"
  >
    <path
      fill={fill ?? "#353535"}
      d="M15 16.8c0 .66-.557 1.2-1.247 1.2H1.247C.56 18 0 17.461 0 16.8c0-3.976 3.358-7.2 7.5-7.2 4.142 0 7.5 3.224 7.5 7.2zm-7.5-5.6c-3.082 0-5.605 2.294-5.819 5.2H13.32c-.214-2.906-2.737-5.2-5.819-5.2zm0-2.4c-2.531 0-4.583-1.97-4.583-4.4C2.917 1.97 4.969 0 7.5 0s4.583 1.97 4.583 4.4c0 2.43-2.052 4.4-4.583 4.4zm0-1.6c1.61 0 2.917-1.254 2.917-2.8 0-1.546-1.306-2.8-2.917-2.8-1.61 0-2.917 1.254-2.917 2.8 0 1.546 1.306 2.8 2.917 2.8z"
    ></path>
  </svg>
)


export default SvgMyProfileIcon